import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import front from '@/../static/js/proto/CtpFront';

/**
 * 选择合约的键盘
 */
@Component({
  name: 'TargetKeyboard',
})
export default class OrderPriceKeyboard extends Vue {
  @Prop()
  public orderPrice;
  @Prop()
  public orderPriceType;
  @Prop()
  public exclude: Node | Node[] | ((current: Node) => boolean);
  @Prop()
  public boardPrice;

  public handleClose() {
    this.$emit('close');
  }
  public orderInput(n) {
    this.$store.commit('keyBoard/changePriceFlage', false);
    const o = {
      1: front.con_opponent_price,
      2: front.con_last_price,
      3: front.con_market_price,
      4: front.con_plusone_tick_price,
    };

    this.$emit('update:orderPriceType', o[n]);
  }
  public onPriceChange(v) {
    this.$emit('update:orderPriceType', front.con_limit_price);
    this.$emit('update:orderPrice', v);
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/OrderPriceKeyboard/OrderPriceKeyboard.ts